
const fieldUtils = {

  alignments: [
    { label: 'Left', value: 'LEFT' },
    { label: 'Right', value: 'RIGHT' },
    { label: 'Centered', value: 'CENTER' },
    { label: 'Justified', value: 'JUSTIFY' }
  ]

};

export default fieldUtils;
